export const DEFAULT_INACTIVITY_TIMEOUT_DURATION_MS = 30 * 60 * 1000;
export const DEFAULT_INACTIVITY_WARNING_DURATION_MS = 5 * 60 * 1000;

export const E2E_OVERRIDE_ENABLED_KEY = "app_e2e_inactivity_override";
export const E2E_TIMEOUT_MS_KEY = "app_e2e_inactivity_timeout_ms";
export const E2E_WARNING_MS_KEY = "app_e2e_inactivity_warning_ms";

export const DEFAULT_INACTIVITY_DURATIONS = {
    timeoutDuration: DEFAULT_INACTIVITY_TIMEOUT_DURATION_MS,
    warningDuration: DEFAULT_INACTIVITY_WARNING_DURATION_MS,
} as const;

type StorageReader = Pick<Storage, "getItem"> | null | undefined;

const parsePositiveNumber = (raw: string | null): number | null => {
    if (!raw) {
        return null;
    }

    const parsed = Number(raw);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        return null;
    }

    return parsed;
};

export const resolveInactivityDurations = (
    storage: StorageReader,
    nodeEnv: string | undefined = process.env.NODE_ENV
) => {
    const defaults = {
        timeoutDuration: DEFAULT_INACTIVITY_TIMEOUT_DURATION_MS,
        warningDuration: DEFAULT_INACTIVITY_WARNING_DURATION_MS,
    };

    if (!storage || nodeEnv === "production") {
        return defaults;
    }

    try {
        const isOverrideEnabled =
            storage.getItem(E2E_OVERRIDE_ENABLED_KEY) === "1";
        if (!isOverrideEnabled) {
            return defaults;
        }

        const timeoutOverride = parsePositiveNumber(
            storage.getItem(E2E_TIMEOUT_MS_KEY)
        );
        const warningOverride = parsePositiveNumber(
            storage.getItem(E2E_WARNING_MS_KEY)
        );

        const timeoutDuration =
            timeoutOverride && timeoutOverride >= 5000
                ? timeoutOverride
                : defaults.timeoutDuration;

        const warningCandidate =
            warningOverride && warningOverride >= 1000
                ? warningOverride
                : defaults.warningDuration;

        const warningDuration = Math.max(
            1000,
            Math.min(warningCandidate, timeoutDuration - 1000)
        );

        return { timeoutDuration, warningDuration };
    } catch {
        return defaults;
    }
};
